export default {
  next: 'ذخیره و مرحله‌ی بعدی',
  generalInformation: 'اطلاعات کلی',
  profilePicture: 'تصاویر پروفایل',
  socialConnections: 'شبکه‌های اجتماعی و ارتباطات',
  documents: 'مدیریت محتوا',
  createProfile: 'ایجاد پروفایل',
  editProfile: 'ویرایش پروفایل',
  save: 'ذخیره',
  finish: 'پایان و دریافت اپ',
  saveAndFinish: 'ذخیره و پایان',
  exit: 'خروج',
};
